import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { CardMask } from '../card-mask/card-mask';
import { TrackClickDirective } from '../../directives/track-click.directive';
import { runtimeLogger } from '../../utils/runtime-logger.util';

export interface SummaryCardData {
  borderColor: string;
  icon: string;
  iconBackgroundColor: string;
  title: string;
  subtitle?: string;
  items: {
    name: string;
    value: number;
  }[];
  buttonText?: string;
  buttonRoute?: string;
  tooltipText?: string;
  trackEvent?: string;
  trackCategory?: string;
  trackLabel?: string;
  /** Quando true, desabilita navegação e exibe rótulo 'Em breve' */
  comingSoon?: boolean;
}

@Component({
  selector: 'app-summary-card',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatDividerModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    CardMask,
    TrackClickDirective
  ],
  templateUrl: './summary-card.html',
  styleUrls: ['./summary-card.scss']
})
export class SummaryCard {
  @Input() data!: SummaryCardData;
  @Input() hasMask: boolean = false;

  activeTooltipButton: 'info' | null = null;

  constructor(private router: Router) { }

  getIconBackgroundWithOpacity(): string {
    return this.hexToRgba(this.data.iconBackgroundColor, 0.4);
  }

  private hexToRgba(hex: string, opacity: number): string {
    hex = hex.replace('#', '');
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  getButtonText(): string {
    return this.data.buttonText || 'Ver mais';
  }

  onMouseEnter(): void {
    runtimeLogger.debug('Tooltip deveria estar visível');
  }

  formatValue(value: number): string {
    return value === 0 ? '-' : value.toString();
  }

  onButtonClick(): void {
    if (this.data.buttonRoute) {
      this.router.navigate([this.data.buttonRoute]);
    }
  }

  onInfoButtonClick(event: Event): void {
    event.stopPropagation();
    this.activeTooltipButton = this.activeTooltipButton === 'info' ? null : 'info';
  }

  closeTooltip(): void {
    this.activeTooltipButton = null;
  }
}
